export default __webpack_public_path__ + "static/media/5_flows_for_the_pelvic_floor.9a5db28a.webp";